import { useEffect, useRef } from 'react';
import { withRouter } from 'react-router';
import { store } from '../../redux/store';
import Intercom from '@intercom/messenger-js-sdk';

const ChatPlatformIntercom = ({ location }) => {
    const initNumRef = useRef(0);

    const initIntercom = (info = {}, star = 0) => {
        if (info?.id && initNumRef.current === 0) {
            try {
                // 版本名称
                const planInfo = {
                    1: "Free", 2: "Professional", 3: "Premium",
                }
                // 价格
                const myPlan = {
                    2: "$29.99", 4: "$59.99", 8: "$23.99", 9: "$47.99",
                }
                const plan_format = ![2, 3].includes(info.level) ? (planInfo[info.level] || '') : `${planInfo[info.level]} ${myPlan[info.pricing_plan_id]}`;
                Intercom({
                    app_id: process.env.REACT_APP_ARMS_ENV === 'prod' ? "t6tndyrj" : "hntligmo",    // 区分测试和线上id  前：正  后：测
                    from_app: "Seoant",                                                     // 来源app名称
                    email: info.email,                                                      // 邮箱
                    name: info.shop_owner,                                                    // 商店名称
                    user_id: `Seoant_${info.id}`,                                           // app名称_uid
                    plan: plan_format,                                                      // 套餐 
                    shop_name: info.name,                                                   // 店铺名称`
                    shopify_store_version: info.plan_display_name,                          // 店铺版本
                    review: star ? `${star}-star` : 'no review',                            // 评分
                    review_name: star ? info.shopname : 'no review name',                       // 评价用户名
                    // '30-day_orders': info.plan.plan_usage_amount.order_limit,            // 30天订单量
                }) // 可反复触发
            } catch (error) {
                console.error('Failed to initialize Intercom with shop info:', error)
            }
            initNumRef.current += 1;
        }
    }

    useEffect(() => {
        initNumRef.current = 0;  // 重置
        store.subscribe(() => {
            const userInfo = store.getState().public.publicInit;
            if (!userInfo?.shop_data) {
                return
            }
            // 只针对线上
            // if (process.env.REACT_APP_ARMS_ENV === 'prod') {
                initIntercom(userInfo.shop_data, userInfo.head_data.review);   // 触发ic
            // }
        })
    }, [location]);

    return <></>
}

export default withRouter(ChatPlatformIntercom);